import * as React from "react"
import { Appearance, ViewStyle } from "react-native"
import { observer } from "mobx-react-lite"
import { color } from "../../../theme"
import { FastField, FastFieldProps, FieldProps } from "formik"
import { FormControl, FormControlProps } from "../../form-control/form-control"
import _ from "lodash"
import { TxKeyPath } from "../../../i18n"
import { DateTimePicker, DateTimePickerProps } from "../../date-time-picker/date-time-picker"
import en from "../../../i18n/en"
import { FC, useCallback } from "react"

export interface DateTimePickerFieldProps {
  FieldComponent?: React.ComponentType<any>,
  name: string,
  colorScheme?: "light" | "dark",
  txPrefix?: keyof typeof en,
  formControlProps?: FormControlProps,
  dateTimePickerProps?: Omit<DateTimePickerProps,"onValueChange"> & { onValueChange?: (value) => void }
}

const FORM_CONTROL: ViewStyle = {
  paddingHorizontal: 16,
  // marginBottom: 8,
  paddingBottom: 8,
  backgroundColor: color.palette.white
}

const DateTimeFormControl: FC<Omit<DateTimePickerFieldProps, "FieldComponent"|"name"> & (FastFieldProps | FieldProps)> = observer(function DateTimeFormControl(props) {
  const {
    colorScheme = "light" || Appearance.getColorScheme(),
    txPrefix,
    formControlProps: { isDisabled, ...formControlProps } = {}, dateTimePickerProps,
    field, form: { setFieldValue, setFieldTouched }, meta
  } = props;

  const column = field.name.split('.').pop()

  const onValueChange = useCallback(async (value) => {
    setFieldValue(field.name, value || null)
    setFieldTouched(field.name)
  }, [field.name, setFieldTouched, setFieldValue])

  return (<FormControl
    isInvalid={(meta.initialValue || meta.touched) && !!meta.error}
    labelTx={(txPrefix && `${txPrefix}.${_.camelCase(column)}` as TxKeyPath) || undefined}
    colorScheme={colorScheme}
    errorMessage={meta.error}
    style={FORM_CONTROL}
    isDisabled={isDisabled}
    {...formControlProps}
  >
    <DateTimePicker
      colorScheme={colorScheme}
      placeholderTx={(txPrefix && `${txPrefix}.${_.camelCase(column)}Placeholder` as TxKeyPath) || undefined}
      value={field.value}
      isDisabled={isDisabled}
      onValueChange={onValueChange}
      {...dateTimePickerProps}
    />
  </FormControl>);
})

/**
 * Describe your component here
 */
export const DateTimePickerField = observer(function DateTimePickerField(props: DateTimePickerFieldProps) {
  const {
    FieldComponent = FastField,
    name, colorScheme = "light" || Appearance.getColorScheme(),
  } = props

  return (
    <FieldComponent name={name}>
      {(fieldProps: FastFieldProps|FieldProps) => (
        <DateTimeFormControl colorScheme={colorScheme} {...props} {...fieldProps} />
      )}
    </FieldComponent>
  )
})
